import { render, staticRenderFns } from "./IconInboxSolid.vue?vue&type=template&id=319a0b0c"
import script from "./IconInboxSolid.vue?vue&type=script&lang=js"
export * from "./IconInboxSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports